import { render } from "./project-view-header.vue?vue&type=template&id=5aa6a008"
import script from "./project-view-header.vue?vue&type=script&lang=js"
export * from "./project-view-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__